import { useDecision } from '@optimizely/react-sdk'

import { hasScopesPermission } from '@tribeplatform/gql-client/lib'
import { Space } from '@tribeplatform/gql-client/types'
import { Tabs } from '@tribeplatform/react-ui-kit/Tabs'

import { FeaturesList } from '../../lib/optimizely/feature.list'
import { SpaceMembershipRequests } from '../Space/SpaceMembershipRequests'
import { SpaceMemberList } from './SpaceMemberList'

export const WhySpaceMemberList = ({ space }: { space: Space }) => {
  const [decisionModeration] = useDecision(FeaturesList.NewModerationPanel)
  const [canApproveSpaceMembershipRequest] = hasScopesPermission(space, [
    'approveSpaceMembershipRequest',
  ])

  if (
    !decisionModeration &&
    canApproveSpaceMembershipRequest &&
    space.inviteOnly
  ) {
    return (
      <div>
        <Tabs.Group>
          <Tabs.List variant="pills" fullWidth>
            <Tabs.Tab>All members</Tabs.Tab>
            <Tabs.Tab>Member requests</Tabs.Tab>
          </Tabs.List>
          <Tabs.Panels>
            <Tabs.Panel>
              <SpaceMemberList spaceId={space.id} key="space-members-list" />
            </Tabs.Panel>
            <Tabs.Panel>
              <SpaceMembershipRequests
                spaceId={space.id}
                key="space-requests-list"
              />
            </Tabs.Panel>
          </Tabs.Panels>
        </Tabs.Group>
      </div>
    )
  }
  return <SpaceMemberList spaceId={space.id} key="members-list" />
}
